import { render, staticRenderFns } from "./SocialAttendanceTypeEdit.vue?vue&type=template&id=365ebe97&"
import script from "./SocialAttendanceTypeEdit.js?vue&type=script&lang=js&"
export * from "./SocialAttendanceTypeEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports